import { useRef, useLayoutEffect } from "react";
import "./slider2.css";

interface Slider2Props {
  title: string;
  value: number;
  onChange: (value: number) => void;
  onPositionChange?: (centerY: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  unit?: string;
  tooltip?: React.ReactNode;
}

const Slider2: React.FC<Slider2Props> = ({
  title,
  value,
  onChange,
  onPositionChange,
  min = 0,
  max = 100,
  disabled = false,
  unit = "%",
  tooltip,
}) => {
  const trackRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (trackRef.current && onPositionChange) {
      const rect = trackRef.current.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;
      onPositionChange(centerY);
    }
  }, [onPositionChange]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(Number(event.target.value));
    }
  };

  const percentage = ((value - min) / (max - min)) * 100;
  const displayValue = unit === "%" ? Math.round(percentage) : value;

  return (
    <div className={`slider2-container ${disabled ? "slider2-disabled" : ""}`}>
      <div className="slider2-header">
        <div className="slider2-title-with-tooltip">
          <h4 className="slider2-title">{title}</h4>
          {tooltip}
        </div>
      </div>
      <div className="slider2-track-container">
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          className="slider2-input"
          disabled={disabled}
        />
        <div
          ref={trackRef}
          className="slider2-track"
          style={
            { "--slider2-progress": `${percentage}%` } as React.CSSProperties
          }
        >
          <div className="slider2-progress"></div>
        </div>
        <div
          className="slider2-value-display"
          style={
            { "--slider2-progress": `${percentage}%` } as React.CSSProperties
          }
        >
          {displayValue}
          {unit}
        </div>
      </div>
    </div>
  );
};

export default Slider2;
